// Client für die Geräte-/Räume-/Strom-Endpoints des SmartHaus-Backends.
// Gleiche Konventionen wie vacuum.js: nginx-Proxy /api (Heimnetz-only),
// siehe FastAPI-Docs unter /docs auf dem Backend.

import { req } from './vacuum'

const BASE_URL = '/api'

export const smarthausApi = {
  baseUrl: BASE_URL,

  // Geräte
  devices: () => req('/devices'),
  deviceOn: (id, on) =>
    req(`/devices/${encodeURIComponent(id)}/on`, { method: 'POST', body: { on } }),
  deviceColor: (id, red, green, blue, brightness = null) =>
    req(`/devices/${encodeURIComponent(id)}/color`, { method: 'POST', body: { red, green, blue, brightness } }),
  deviceBrightness: (id, brightness) =>
    req(`/devices/${encodeURIComponent(id)}/brightness`, { method: 'POST', body: { brightness } }),

  // Räume
  rooms: () => req('/rooms'),
  roomCreate: (name, deviceIds) =>
    req('/rooms', { method: 'POST', body: { name, device_ids: deviceIds } }),
  roomUpdate: (id, payload) =>
    req(`/rooms/${encodeURIComponent(id)}`, { method: 'PUT', body: payload }),
  roomDelete: (id) =>
    req(`/rooms/${encodeURIComponent(id)}`, { method: 'DELETE' }),
  roomOn: (id, on) =>
    req(`/rooms/${encodeURIComponent(id)}/on`, { method: 'POST', body: { on } }),
  roomColor: (id, red, green, blue, brightness = null) =>
    req(`/rooms/${encodeURIComponent(id)}/color`, { method: 'POST', body: { red, green, blue, brightness } }),
  // Raum-Gruppen der Hue-Bridge übernehmen (mergt per Name, entfernt nichts).
  roomsImportHue: () => req('/rooms/import-hue', { method: 'POST' }),

  // Routinen (Aktionslisten, toggelbar — auch als Trigger auf der Vacuum-Karte)
  routines: () => req('/routines'),
  routineCreate: (payload) => req('/routines', { method: 'POST', body: payload }),
  routineUpdate: (id, payload) =>
    req(`/routines/${encodeURIComponent(id)}`, { method: 'PUT', body: payload }),
  routineDelete: (id) =>
    req(`/routines/${encodeURIComponent(id)}`, { method: 'DELETE' }),
  routineActive: (id, active) =>
    req(`/routines/${encodeURIComponent(id)}/active`, { method: 'POST', body: { active } }),
  routineToggle: (id) =>
    req(`/routines/${encodeURIComponent(id)}/toggle`, { method: 'POST' }),
  routineSetPosition: (id, x, y) =>
    req(`/routines/${encodeURIComponent(id)}/position`, { method: 'PUT', body: { x: Math.round(x), y: Math.round(y) } }),
  routineClearPosition: (id) =>
    req(`/routines/${encodeURIComponent(id)}/position`, { method: 'DELETE' }),

  // Strom
  powerSummary: () => req('/power/summary'),
  powerDaily: (days = 30) => req(`/power/daily?days=${days}`),
  // Als <img src> nutzbar; t = Cache-Buster.
  powerChartUrl: (hours = 24) => `${BASE_URL}/power/chart.png?hours=${hours}&t=${Date.now()}`,

  // System
  // Startet den systemd-Dienst `smarthaus` neu. Antwortet sofort mit 202, der
  // eigentliche Neustart läuft ~1 s später im Backend — die Verbindung bricht
  // dann ab, der 202-Response ist aber bereits durch.
  systemRestart: () => req('/system/restart', { method: 'POST' }),
}

// Preset-Palette für Raum-/Lampenfarben.
export const COLOR_PRESETS = [
  { label: 'Warmweiß', rgb: [255, 214, 170] },
  { label: 'Kaltweiß', rgb: [255, 255, 255] },
  { label: 'Gemütlich', rgb: [255, 147, 41] },
  { label: 'Rot', rgb: [255, 60, 40] },
  { label: 'Grün', rgb: [80, 200, 120] },
  { label: 'Blau', rgb: [70, 130, 240] },
  { label: 'Lila', rgb: [170, 80, 220] },
]

export const CATEGORY_ICONS = {
  lamp: 'mdi-lightbulb-on-10',
  plug: 'mdi-power-socket-de',
  vacuum: 'mdi-robot-vacuum',
  other: 'mdi-help-circle-outline',
}

export function rgbToHex(r, g, b) {
  const h = (c) => c.toString(16).padStart(2, '0')
  return '#' + h(r) + h(g) + h(b)
}
